import { IconWrapper } from '../runtime';
export default IconWrapper('folder-equipment-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.96667 0.999725H2.25C1.00736 0.999725 0 2.02229 0 3.2837V17.7715C0 19.4534 1.34315 20.8168 3 20.8168H21C22.6569 20.8168 24 19.4534 24 17.7715V6.32899C24 4.64712 22.6569 3.2837 21 3.2837H12.1583C11.5661 3.2837 10.987 3.10574 10.4942 2.77224L8.63077 1.51118C8.13797 1.17769 7.55895 0.999725 6.96667 0.999725Z",
      "fill": "#317FF2"
    }
  }), h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + 'b108d586' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 8.54502C0 6.86315 1.34315 5.49973 3 5.49973H21C22.6569 5.49973 24 6.86315 24 8.54502V18.9544C24 20.6363 22.6569 21.9997 21 21.9997H3C1.34315 21.9997 0 20.6363 0 18.9544L0 8.54502Z",
      "fill": 'url(#' + props.id + '96632208' + ')'
    }
  })]), h("g", [h("g", [h("g", [h("path", {
    "attrs": {
      "d": "M8.25 9.74973C7.83579 9.74973 7.5 10.0855 7.5 10.4997V15.7497H12.75V12.3747C12.75 12.1676 12.9179 11.9997 13.125 11.9997H15.75V10.4997C15.75 10.0855 15.4142 9.74973 15 9.74973H8.25Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.3125 16.4997H12.75V17.6247H7.3125C7.00184 17.6247 6.75 17.3729 6.75 17.0622C6.75 16.7516 7.00184 16.4997 7.3125 16.4997Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.5 13.1247C13.5 12.9176 13.6679 12.7497 13.875 12.7497H16.875C17.0821 12.7497 17.25 12.9176 17.25 13.1247V17.6247C17.25 17.8318 17.0821 17.9997 16.875 17.9997H13.875C13.6679 17.9997 13.5 17.8318 13.5 17.6247V13.1247ZM14.625 16.8747C14.625 16.6676 14.7929 16.4997 15 16.4997H15.75C15.9571 16.4997 16.125 16.6676 16.125 16.8747C16.125 17.0818 15.9571 17.2497 15.75 17.2497H15C14.7929 17.2497 14.625 17.0818 14.625 16.8747Z",
      "fill": "white"
    }
  })])])])]), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + 'b108d586',
      "x": "0",
      "y": "5.49973",
      "width": "24",
      "height": "16.5",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-0.75"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in2": "shape",
      "result": "effect1_innerShadow_3034_955"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '96632208',
      "x1": "2.25",
      "y1": "6.39352",
      "x2": "19.4765",
      "y2": "24.6325",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});